/* Andy Cooks – smart recipe search.
   When someone searches in plain words ("quick chicken dinner", "something chinese"), ask the Recipes by Andy
   AI endpoint what they mean, turn its tags into the recipes hub's own filters and open the hub already filtered.
   Before going there it checks the recipe index so the filters actually match recipes, dropping the least
   important ones if needed. Anything that goes wrong (slow, no answer, no matches) falls back to normal search. */
(function () {
  'use strict';
  if (window.ACAISearch) return;
  var EP = '/apps/recipe-reviews/ai-search?context=recipe&q=';
  var TIMEOUT = 5000;  /* the AI usually answers in 2-3 seconds */
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var pv = (location.search.match(/preview_theme_id=\d+/) || [''])[0];

  var CUISINES = ['italian', 'chinese', 'japanese', 'korean', 'thai', 'vietnamese', 'indian', 'mexican', 'american', 'british', 'french', 'australian', 'greek', 'spanish', 'middle eastern', 'lebanese', 'filipino', 'malaysian', 'indonesian', 'irish', 'german', 'caribbean', 'african'];
  var MEALS = { breakfast: 'breakfast', lunch: 'lunch', dinner: 'dinner', snack: 'snack', snacks: 'snack', dessert: 'dessert', desserts: 'dessert' };
  var EXTRAS = { vegetarian: 'veg', easy: 'easy', 'make ahead': 'ahead' };

  function low(s) { return String(s || '').toLowerCase().trim(); }

  /* AI answer -> hub filters (same names the hub reads from the URL) */
  function toFilters(data) {
    var f = { time: '', cu: [], meal: [], x: [], q: [] };
    var items = Array.isArray(data.matches) && data.matches.length
      ? data.matches
      : (data.tags || []).map(function (t) { return { value: t, type: 'tag' }; });
    items.forEach(function (m) {
      var v = low(m && m.value); if (!v) return;
      if (CUISINES.indexOf(v) >= 0) { if (f.cu.indexOf(v) < 0) f.cu.push(v); return; }
      if (MEALS[v]) { if (f.meal.indexOf(MEALS[v]) < 0) f.meal.push(MEALS[v]); return; }
      if (v === 'quick') { f.time = '30'; return; }
      if (EXTRAS[v]) { if (f.x.indexOf(EXTRAS[v]) < 0) f.x.push(EXTRAS[v]); return; }
      if (f.q.indexOf(v) < 0) f.q.push(v);
    });
    return f;
  }

  /* same rules as the hub's fMatch (assets/ac-recipes.js) */
  function matches(r, f) {
    var tl = r.tl || [];
    if (f.time === '30' && !(r.m > 0 && r.m <= 30)) return false;
    if (f.cu.length && !f.cu.some(function (c) { return tl.indexOf(c) >= 0; })) return false;
    if (f.meal.length && !f.meal.some(function (c) { return tl.indexOf(c) >= 0; })) return false;
    for (var i = 0; i < f.x.length; i++) {
      var x = f.x[i];
      if (x === 'veg' && tl.indexOf('vegetarian') < 0) return false;
      if (x === 'easy' && tl.indexOf('easy') < 0) return false;
      if (x === 'ahead' && tl.indexOf('make ahead') < 0) return false;
    }
    if (f.q.length) {
      var hay = ((r.nt || r.t || '') + ' ' + (r.ng || '') + ' ' + tl.join(' ')).toLowerCase();
      var words = f.q.join(' ').split(/\s+/).filter(Boolean);
      for (var j = 0; j < words.length; j++) if (hay.indexOf(words[j].replace(/s$/, '')) < 0) return false;
    }
    return true;
  }
  function count(list, f) { var n = 0; for (var i = 0; i < list.length; i++) if (matches(list[i], f)) n++; return n; }

  /* keep the filters that still leave recipes: meal first to go, then easy/make-ahead, cuisine, quick.
     "Vegetarian" is never dropped - if nothing vegetarian matches, normal search takes over instead. */
  function settle(list, f) {
    if (count(list, f) > 0) return f;
    var steps = [function (g) { g.meal = []; }, function (g) { g.x = g.x.filter(function (x) { return x === 'veg'; }); }, function (g) { g.cu = []; }, function (g) { g.time = ''; }];
    var g = JSON.parse(JSON.stringify(f));
    for (var i = 0; i < steps.length; i++) { steps[i](g); if (count(list, g) > 0) return g; }
    return null;
  }

  function hubURL(f) {
    var p = new URLSearchParams();
    if (f.q.length) p.set('q', f.q.join(' ').slice(0, 60));
    if (f.time) p.set('time', f.time);
    if (f.cu.length) p.set('cu', f.cu.join(','));
    if (f.meal.length) p.set('meal', f.meal.join(','));
    if (f.x.length) p.set('x', f.x.join(','));
    if (pv) { var kv = pv.split('='); p.set(kv[0], kv[1]); }
    return root + 'blogs/recipes?' + p.toString();
  }

  function withTimeout(promise, ms) {
    return Promise.race([promise, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || form.__acAiBusy) return;
    var action = form.getAttribute('action') || '';
    if (!/\/search\/?$/.test(action.split('?')[0])) return;
    var input = form.querySelector('input[name="q"]');
    var q = input ? input.value.trim() : '';
    /* only plain-language searches (2+ words) go to the AI; single words keep the instant search */
    if (q.split(/\s+/).filter(Boolean).length < 2 || q.length > 120) return;
    e.preventDefault();
    form.__acAiBusy = true;
    form.setAttribute('aria-busy', 'true');
    var oldOpacity = form.style.opacity, oldCursor = form.style.cursor;
    form.style.opacity = '0.55'; form.style.cursor = 'progress';
    var fallback = function () { form.__acAiBusy = false; form.removeAttribute('aria-busy'); form.style.opacity = oldOpacity; form.style.cursor = oldCursor; form.submit(); };

    var ai = withTimeout(fetch(EP + encodeURIComponent(q), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('ai ' + r.status); return r.json(); }), TIMEOUT);
    var idx = window.ACIndex && ACIndex.load ? ACIndex.load() : Promise.resolve(null);

    Promise.all([ai, idx]).then(function (res) {
      var data = res[0], list = res[1];
      if (!data || data.success === false || data.recipeIntent === false) return fallback();
      var f = toFilters(data);
      if (!f.time && !f.cu.length && !f.meal.length && !f.x.length && !f.q.length) return fallback();
      if (list && list.length) { f = settle(list, f); if (!f) return fallback(); }
      location.href = hubURL(f);
    }).catch(fallback);
  }

  document.addEventListener('submit', onSubmit, true);
  window.ACAISearch = { toFilters: toFilters, settle: settle, hubURL: hubURL };
})();
